import { InputAdornment, TextField } from "@mui/material";
import React from "react";
import SearchIcon from "@mui/icons-material/Search";

export default function DebouncedFilter({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}) {
  const [value, setValue] = React.useState(initialValue);
  const lastEmitted = React.useRef(initialValue);
  const onChangeRef = React.useRef(onChange);

  React.useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  React.useEffect(() => {
    // Do not fire again for a value that was already emitted: unrelated re-renders
    // previously restarted the timer and re-sent the same term (resetting pagination).
    if (value === lastEmitted.current) return;

    const timeout = setTimeout(() => {
      lastEmitted.current = value;
      onChangeRef.current(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [debounce, value]);

  return (
    <TextField
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
      size="small"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      {...props}
    />
  );
}
